{
  "common": {
    "loading": "Loading...",
    "chat": "Chat",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "none": "None",
    "unknown": "Unknown",
    "notSet": "Not set",
    "expand": "Expand",
    "collapse": "Collapse",
    "clear": "Clear",
    "send": "Send",
    "error": "Error",
    "unknownError": "An unknown error occurred.",
    "menu": "Menu",
    "delete": "Delete",
    "retry": "Retry",
    "edit": "Edit",
    "na": "N/A",
    "toggleFullscreen": "Toggle fullscreen",
    "reloadPage": "Reload page",
    "systemResponse": "Clinical Portal Auto-Response",
    "completeTaskAction": "Mark complete",
    "deleteTaskAction": "Delete task",
    "notes": "Notes (not seen by client)",
    "addNote": "Add note",
    "interpretation": {
      "positive": "Positive",
      "negative": "Negative",
      "invalid": "Invalid",
      "uninterpretable": "Uninterpretable"
    },
    "actionsTaken": {
      "chat_with_client": "Chatted with client",
      "nudge_sent": "Nudge sent",
      "scheduled_bus_appt": "Appointment scheduling support",
      "referred_to_social_worker": "Referred to social worker",
      "referred_for_services": "Referred for services",
      "no_action_taken": "No further action required",
      "handled_by_chatbot": "Handled by chatbot (No further action required)",
      "incorrect_flag": "Incorrect flag (No further action required)",
      "other": "Other"
    },
    "language": {
      "af": "Afrikaans",
      "en": "English",
      "fr": "French",
      "nd": "North Ndebele",
      "sn": "Shona",
      "sw": "Swahili",
      "zu": "Zulu"
    },
    "activeTasks_one": "({{count}} active task)",
    "activeTasks_other": "({{count}} active tasks)",
    "retrySendAction": "In a few minutes, click here to try again.",
    "yes": "Yes",
    "no": "No"
  },
  "taskTypes": {
    "request_to_chat": "Request to chat",
    "pending_hcw_message": "Pending message",
    "followup": "Follow-up",
    "possible_interest_in_prep_or_pep": "Possible interest in PrEP/PEP",
    "interest_in_self_testing": "Interest in self-testing",
    "concern_chat_content": "AI-flagged concern",
    "concern_interpretation_mismatch": "AI mismatch",
    "concern_invalid_test": "Invalid test result",
    "concern_positive_test": "Positive test result",
    "concern_negative_test": "Negative test result",
    "concern_risk_other": "HIV vulnerability: Other",
    "concern_risk_score": "HIV vulnerability: High",
    "concern_self_reported_hiv_positive": "Self-reported HIV positive status or test [DEPRECATED]",
    "concern_self_reported_hiv_positive_status": "Self-reported HIV positive",
    "celosia_concern_hiv_risk_score": "HIV Vulnerability: High",
    "celosia_mental_health_further_screening_required": "Conduct SSQ14 screening",
    "celosia_potential_sti": "Potential STI",
    "mangrove_alcohol_further_screening_required": "Harmful alcohol use: Screen further",
    "mangrove_anxiety_further_screening_required": "Anxiety: Screen further",
    "mangrove_depression_further_screening_required": "Depression: Screen further",
    "mangrove_tb_vulnerable": "Consider TB testing",
    "protea_alcohol_further_screening_required": "Harmful alcohol use: Screen further",
    "protea_anxiety_further_screening_required": "Anxiety: Screen further",
    "protea_depression_further_screening_required": "Depression: Screen further",
    "urgent_request_to_chat": "URGENT: Request to chat"
  },
  "concernFlags": {
    "hate_harassment": "Hate/harassment",
    "self_harm_suicide": "Self-harm/suicide",
    "explicit_content_sexual_assault": "Explicit content/sexual assault",
    "gbv_sexual_assault": "GBV/Sexual assault",
    "sex_with_minor": "Sex with minor",
    "violence": "Violence",
    "illicit": "Illicit activity",
    "illicit_violent": "Illicit activity",
    "unknown": "Unknown"
  },
  "riskAssessmentTypes": {
    "common": {
      "explanationTitle": "Questions and answers impacting score",
      "valueNotPresent": "Not collected"
    },
    "phithos_hiv_risk": {
      "title": "HIV vulnerability",
      "explanationTitle": "Top factors impacting score",
      "valueNotPresent": "",
      "about": "<i>AI-calculated based on data entered by client during chat conversations. Top factors impacting the score are described above.</i>"
    },
    "celosia_hiv_risk": {
      "title": "HIV vulnerability",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">A score is calculated based on client responses during AI chat conversations. It is only generated if all questions are answered.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />Low = 0, Medium = 1-2, High = 3-6</p></i>"
    },
    "celosia_mental_health": {
      "title": "PHQ-2",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>PHQ-2</b> inquires about the frequency of depressed mood over the past two weeks ranging from answers of not at all to nearly every day. Answers are collected during AI-guided chat interactions. Those with a high score should be further evaluated.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />Depressive disorder unlikely = 0-2, Further screening required = 3-6</p></i>"
    },
    "mangrove_alcohol": {
      "title": "Alcohol",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>Alcohol Use Disorders Identification (AUD-C)</b> test inquires about the frequency of alcohol use. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 3 or less, Further screening required = 4 or more</p></i>"
    },
    "mangrove_anxiety": {
      "title": "Anxiety",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>Generalized Anxiety Disorder (GAD-2)</b> questionnaire inquires about the frequency of being bothered by certain thoughts over the past two weeks. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 2 or less, Further screening required = 3 or more</p></i>"
    },
    "mangrove_depression": {
      "title": "Depression",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>PHQ-2</b> inquires about the frequency of depressed mood over the past two weeks. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 0-2, Further screening required = 3-6</p></i>"
    },
    "mangrove_tb": {
      "title": "TB",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>TB screening tool</b> inquires about the presence of TB-related symptoms. Those who screen <b>Vulnerable</b> should be further evaluated.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />Vulnerable if cough present for over 2 weeks, OR is HIV positive status and has a cough, OR high fever in the past few weeks, OR losing weight without trying, OR night sweats.</p></i>"
    },
    "protea_alcohol": {
      "title": "Alcohol",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>Alcohol Use Disorders Identification (AUD-C)</b> test inquires about the frequency of alcohol use. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 3 or less, Further screening required = 4 or more</p></i>"
    },
    "protea_anxiety": {
      "title": "Anxiety",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>Generalized Anxiety Disorder (GAD-2)</b> questionnaire inquires about the frequency of being bothered by certain thoughts over the past two weeks. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 2 or less, Further screening required = 3 or more</p></i>"
    },
    "protea_depression": {
      "title": "Depression",
      "about": "<i><p style=\"margin-block-start: 0; margin-block-end: 0;\">The <b>PHQ-2</b> inquires about the frequency of depressed mood over the past two weeks. Answers are collected during AI-guided chat interactions. Those with a high score should be further screened.</p><p style=\"margin-block-end: 0;\"><b>Scoring</b><br />No abnormality detected = 0-2, Further screening required = 3-6</p></i>"
    }
  },
  "confidenceScoreClassifications": {
    "high": "Confident",
    "medium": "Somewhat confident",
    "low": "Low confidence",
    "unknown": "Unknown"
  },
  "riskScoreClassifications": {
    "common": {
      "high": {
        "shortName": "High"
      },
      "medium": {
        "shortName": "Medium"
      },
      "low": {
        "shortName": "Low"
      },
      "further_screening_required": {
        "shortName": "Vulnerable",
        "longName": "VULNERABLE: Further screening required"
      },
      "unknown": {
        "shortName": "Unknown"
      }
    },
    "celosia_mental_health": {
      "depressive_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Depressive disorder unlikely"
      }
    },
    "mangrove_alcohol": {
      "alcohol_use_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Alcohol use disorder unlikely"
      }
    },
    "mangrove_anxiety": {
      "anxiety_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Anxiety disorder unlikely"
      }
    },
    "mangrove_depression": {
      "depressive_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Depressive disorder unlikely"
      }
    },
    "mangrove_tb": {
      "tb_vulnerable": {
        "shortName": "Vulnerable",
        "longName": "VULNERABLE: Further screening required"
      },
      "negative_screen": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: TB unlikely"
      }
    },
    "protea_alcohol": {
      "alcohol_use_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Alcohol use disorder unlikely"
      }
    },
    "protea_anxiety": {
      "anxiety_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Anxiety disorder unlikely"
      }
    },
    "protea_depression": {
      "depressive_disorder_unlikely": {
        "shortName": "Unlikely",
        "longName": "UNLIKELY: Depressive disorder unlikely"
      }
    }
  },
  "collectedDataCategories": {
    "clientProfile": "Client profile",
    "careAndSupport": "Care & support",
    "hivInformation": "HIV information",
    "tbInformation": "TB information",
    "sexualHealthAndBehavior": "Sexual health & behavior",
    "mentalHealthAndSafety": "Mental health & safety",
    "generalHealth": "General health",
    "partnerInformation": "Client's partner(s) info",
    "other": "Other"
  },
  "ErrorPage": {
    "title": "Unexpected error",
    "body": "Sorry, an unexpected error has occurred. Please return to the home page and try again.",
    "goHome": "Return to home page"
  },
  "PrimaryAppBar": {
    "noAccount": "Don't have an account?",
    "issuesOccurred_one": "{{count}} message failed to send",
    "issuesOccurred_other": "{{count}} messages failed to send",
    "signUp": "Sign up",
    "signOut": "Sign out",
    "shareFeedback": "Share Feedback"
  },
  "TermsOfUse": {
    "termsOfUseTitle": "App Use Agreements",
    "termsOfUseBody": "By selecting &quot;I agree to the App Use Agreements&quot; or using the App, you agree to the HealthPulse Clinical Portal <a href=\"https://healthpulsenow.org/hw-apps/clinical-portal/privacy-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a> and <a href=\"https://healthpulsenow.org/hw-apps/clinical-portal/eula\" target=\"_blank\" rel=\"noopener noreferrer\">End-User License Agreement</a>.<p>If you do not agree, do not select &quot;I agree to the App Use Agreements&quot; and do not use the Clinical Portal.</p>",
    "acceptCheckbox": "I agree to the App Use Agreements",
    "proceed": "Proceed"
  },
  "Login": {
    "welcome": "Welcome back!",
    "welcomePrompt1": "This app will guide you through reviewing client WhatsApp chat summaries and rapid test results."
  },
  "Patients": {
    "landscapeOnly": "This view is only available in landscape mode. Please rotate your device or expand your browser window to continue.",
    "searchPlaceholder": "Search for a client",
    "groupByPatient": "Group tasks by client",
    "readyToChat": "Ready to chat",
    "concerns": "For review",
    "followUps": "Follow-ups",
    "chatsMini": "Chats",
    "concernsMini": "Review",
    "followUpsMini": "Follow-up",
    "oldestAtTop": "(Oldest at top)",
    "mostRecentAtTop": "(Most recent at top)",
    "noTasksWithFilters": "No tasks match the selected filters.",
    "taskLimitReached": "Only the last {{count}} completed tasks show in the list.",
    "navPrevious": "Previous",
    "navNext": "Next",
    "emptyDetailPrompt": "Select a task on the left to view a client's record.",
    "dueDate": "Due {{dueDate}}",
    "shareFeedback": "Share Feedback"
  },
  "Patient": {
    "noName": "No name",
    "preferredLanguage": "The patient prefers to communicate in {{language}}.",
    "calculatedTime": "Calculated {{time}}",
    "healthScoreConfidenceTitle": "Confidence score",
    "lastAssessedTitle": "Last assessed",
    "healthScores": "Health scores",
    "workingInRecord": "Working in record",
    "referralId": "Clinical Portal ID",
    "partnerId": "Partner ID",
    "reminders_one": "The patient has {{count}} reminder.",
    "reminders_other": "The patient has {{count}} reminders.",
    "remindersTitle": "Reminders",
    "reminderType": "Reminder type",
    "reminderDueDate": "Due",
    "reminderCycle": "Cycle",
    "reminderLocation": "Location",
    "showActiveOrRecent": "Show only active & recent",
    "tasks": "Tasks",
    "notes": "Notes",
    "collectedData": "Collected data",
    "addNewTask": "Add new",
    "noItemsToShow": "There are no active or recent items.",
    "noConversationsOrTasks": "This client does not have any AI conversations or tasks.",
    "titleRequired": "Task title is required.",
    "actionsTakenRequired": "Actions taken are required to mark this task as complete.",
    "interpretationRequired": "An interpretation is required to mark this task as complete.",
    "nudge_one": "Nudge",
    "nudge_other": "Nudges",
    "collectedDataInfo": "The data below is self-reported by clients during conversations with the AI chatbot and is not clinically verified.",
    "noCollectedData": "There is no collected data to display for this client.",
    "collectedDataLastUpdated": "Last updated {{date}}",
    "optedOutTitle": "Opted out of Sharing Phone number",
    "optedOutDescription": "This individual has opted out of sharing their phone number with people/businesses they have conversations with."
  },
  "ChatUx": {
    "chat": "Chat with {{name}}",
    "conversationSummaryDetailWarning": "Be mindful about which AI companion summary details you share with the client.",
    "markAsRead": "Mark conversation as read",
    "markAsUnread": "Mark conversation as unread",
    "noMessages": "You have no chat history.",
    "unknownMessageType": "Unknown message type: {{type}}",
    "messageVisibility": "Message visibility",
    "messageVisible": "Visible",
    "messageHiddenAppropriate": "Hidden: Appropriate",
    "messageHiddenInappropriate": "Hidden: Inappropriate",
    "peekFromHidden": "Unhide content",
    "noMessages2": "Send a nudge to initiate a chat.",
    "typeMessage": "Type a message",
    "newMessage": "New message",
    "chatExpiry": "Chat session expires in {{time}}",
    "selectNudge": "Select a nudge",
    "nudge": "Send nudge",
    "sentTemplateMessage": "Sent Template Message: ",
    "sentNudge": "Nudge: ",
    "messageDeliveryFailed": "Your message was blocked by WhatsApp. If related to patient safety, email support@auderenow.org and include the Clinical Portal ID.",
    "messageSendError": "Your last message was not sent to {{name}}. WhatsApp's messaging service may be currently offline.",
    "templateTitles": {
      "none": "-- Select a nudge to send --",
      "chat_ready": "Responding to client request to chat",
      "nurse_available_2": "Client ⮕ Nurse chat request via chatbot",
      "nurse_location_assistance": "Client ⮕ Nurse chat request to find an RDT",
      "concern_reachout_risk": "Nurse ⮕ Client outreach re: concern flag",
      "concern_reachout_result": "Nurse ⮕ Client outreach re: RDT",
      "concern_reachout_other": "Nurse ⮕ Client outreach re: other reason",
      "nurse_available_3": "Client ⮕ Nurse chat request via chatbot",
      "nurse_available_v6": "Client ⮕ Nurse chat request via chatbot",
      "nurse_location_assistance_v2": "Client ⮕ Nurse chat request to find an RDT",
      "nurse_location_assistance_v3": "Responding to HIVST location request",
      "concern_reachout_risk_or_harmful_flag": "Nurse ⮕ Client outreach re: risk score or concern flag",
      "concern_reachout_result_v2": "Nurse ⮕ Client outreach re: RDT",
      "concern_reachout_result_v3": "Nurse ⮕ Client outreach re: RDT",
      "concern_reachout_result_v4": "Nurse ⮕ Client outreach re: RDT",
      "flagged_support_checkin": "Reach out based on flag (no client request)",
      "test_result_followup": "Reach out based on RDT result (no client request)",
      "clinical_portal_request_for_feedback": "Request for feedback (no client request)"
    },
    "templates": {
      "none": "Select a nudge from the list above to send to the client.",
      "chat_ready": "Thank you for your patience, a clinician is now available to answer your questions. Reply to this message to start chatting.",
      "nurse_available_2": "As requested, a nurse is available to chat. Reply to this message when you're ready to start chatting.",
      "nurse_location_assistance": "As requested, we will help you find a nearby clinic. Please let us know your general area or suburb to get started—no need for a full address!",
      "concern_reachout_risk": "Hello, this is a message from your care team. A nurse would like to chat to provide you with additional support and guidance. Reply to this message when you're ready to start chatting.",
      "concern_reachout_result": "Hello, this is a message from your care team. A nurse would like to chat with you about your test result. Reply to this message when you're ready to start chatting.",
      "concern_reachout_other": "Hello, this is a message from your care team. A nurse would like to chat to provide you with additional support and guidance. Reply to this message when you're ready to start chatting.",
      "nurse_available_3": "As requested, a nurse is available to chat. Reply to this message when you're ready.",
      "nurse_available_v6": "Hello, a nurse is available to chat. Please share how they can best support you.",
      "nurse_location_assistance_v2": "As requested, a nurse will help you find a nearby clinic. Please let us know your general area or suburb to get started—no need for a full address!",
      "nurse_location_assistance_v3": "As requested, we will help you find a nearby clinic. Please let us know your general area or suburb to get started—no need for a full address!",
      "concern_reachout_risk_or_harmful_flag": "Hello, this is a message from your care team. A nurse would like to chat to provide you with additional support and guidance.\nReply to this message when you're ready.",
      "concern_reachout_result_v2": "Hello, this is a message from your care team. A nurse would like to chat with you about your test result. Reply to this message when you're ready.",
      "concern_reachout_result_v3": "Hello, this is a message from your care team. A nurse would like to chat with you about your test result. Reply to this message when you're ready.",
      "concern_reachout_result_v4": "Hello, this is a message from your care team. A nurse would like to chat with you about your test result. Reply to this message when you're ready.",
      "flagged_support_checkin": "A real person is available if you'd like additional support. Just reply to this message when you're ready.",
      "test_result_followup": "We're reaching out to discuss your test result. Reply to this message when you're ready to chat.",
      "chat_ready_vimbai_sn": "Tinokutenda nekuva nemoyo murefu, mukoti ava kuwanikwa kupindure mibvunzo yenyu. Pindurai meseji iyi kuti mutange kutaura naye.<br/>---<br/><i>English translation: Thank you for your patience, a nurse is now available to answer your questions. Reply to this message to start chatting.</i>",
      "nurse_location_assistance_vimbai_sn": "Sezvawakumbira, tichakubatsira kutsvaga chipatara chiri pedyo. Ndapota tiudze nzvimbo yawuri kana sabhabha kuti titange - usatipa kero yakazara.<br/>---<br/><i>English translation: As requested, we will help you find a nearby clinic. Please let us know your general area or suburb to get started—no need for a full address!</i>",
      "flagged_support_checkin_vimbai_sn": "Pane munhu chaiye aripo kana uchida rumwe rubatsiro. Ingopindura meseji iyi kana wagadzirira.<br/>---<br/><i>English translation: A real person is available if you'd like additional support. Just reply to this message when you're ready.</i>",
      "test_result_followup_vimbai_sn": "Tiri kukubata kuti tikurukure nezvedudziro yevheneko yako. Pindura meseji iyi kana wagadzirira kutaura.<br/>---<br/><i>English translation: We're reaching out to discuss your test result. Reply to this message when you're ready.</i>",
      "chat_ready_vimbai_nd": "Siyabonga ukubekezela kwakho, uMongikazi usekhona ukuthi aphendule imbuzo yakho. Phendula kumlayezo lowu ukuze uqalise ukuxoxa.<br/>---<br/><i>English translation: Thank you for your patience, a nurse is now available to answer your questions. Reply to this message to start chatting.</i>",
      "nurse_location_assistance_vimbai_nd": "Njengesicelo sakho, UMongikazi uzakuncedisa ukuthi uthole ikilinika eseduzane lawe. Sicela usitshele ukuthi ungaphi kumbe ilokitshi lakho ukuze siqalise-akulasidingeko sokusinika ikheli egcweleyo.<br/>---<br/><i>English translation: As requested, we will help you find a nearby clinic. Please let us know your general area or suburb to get started—no need for a full address!</i>",
      "flagged_support_checkin_vimbai_nd": "Umuntu uqobo ukhona nxa ufuna ukuxhaswa okwengeziweyo, phendula kumlayezo wonalo nxa usulungele ukuxoxa.<br/>---<br/><i>English translation: A real person is available if you'd like additional support. Just reply to this message when you're ready.</i>",
      "test_result_followup_vimbai_nd": "Sixhumana lawe ukuze sixoxe ngempumela yenhlolisiso yakho. Phendula kumlayezo lo nxa usulungele ukuxoxa.<br/>---<br/><i>English translation: We're reaching out to discuss your test result. Reply to this message when you're ready.</i>",
      "chat_ready_zu": "Ngiyabonga ngokubekezela, sekukhona udokotela ongatholakala ukukuphendula. Phendula lo myalezo ukuze siqale ingxoxo.",
      "nurse_location_assistance_zu": "Njengoba ucelile, sizokusiza sithole ikliniki eseduze. Sicela usazise indawo la ukhona noma isigodi—akudingeki unikeze ikheli eliphelele!",
      "flagged_support_checkin_zu": "Uma ufuna usizo olwengeziwe, kukhona umuntu wangempela otholakalayo. Phendula lo myalezo uma usukulungele.",
      "test_result_followup_zu": "Siyaxhumana ukuze sixoxe ngomphumela wakho wokuhlolwa. Phendula lo myalezo uma usukulungele ukukhuluma.",
      "clinical_portal_request_for_feedback_en": "Hi there! I'm a health worker here to support people using {{ficus_program}}. I'd love to know how your experience has been so far. Would you mind sharing some feedback with me?",
      "clinical_portal_request_for_feedback_zu": "Sawubona! 😊 Ngingumsebenzi wezempilo ozokweseka abantu abasebenzisa {{ficus_program}}. Ngingathanda ukwazi ngesipiliyoni sakho kuze kube manje, ungakwazi ukwabelana ngempendulo yakho nami?",
      "clinical_portal_request_for_feedback_sn": "Mhoro! Ndiri mukoti, ndiripo kubatsira vanhu vanoshandisa {{ficus_program}}. Ndinodawo kuziva kuti mashandisiro ako VimbAI urikumatambira sei kusvika pari zvino. Unogona here kugovera mhinduro yako neni?",
      "clinical_portal_request_for_feedback_nd": "Kunjani! Ngingumongikazi, ngikhona ukuthi ngincedisa abantu abasebenzisa i{{ficus_program}}. Ngifuna nje ukuzwisisa ukuthi iVimbAI ikusebenzela njani okwakhathesi, ungathanda yini ukungichazela ngosuhlangane lakho yini?"
    }
  },
  "TaskEntry": {
    "selfTestConcern": "Test result concern",
    "chatConcern": "Chat concern",
    "selfReportedHIVStatusConcern": "Self-reported HIV status concern",
    "toFollowup": "Follow-up",
    "dueDate": "Due {{date}}",
    "createdInfo": "Added by {{name}} | {{date}}",
    "completedInfo": "Marked complete by {{name}} | {{date}} | Actions taken: {{actionsTaken}}",
    "autoCompletedInfo": "Marked complete by {{name}} | {{date}}",
    "deletedInfo": "Deleted by {{name}} | {{date}}",
    "flagForSupervisor": "Flag for review",
    "clearFlagForSupervisor": "Clear review flag"
  },
  "SelfTestEntry": {
    "title": "RDT Result",
    "clinicianResultAdded": "Clinician interpretation added by {{name}}.",
    "selfReportedHivStatus": "The client self-reported an HIV {{result}} test result without uploading a photo of the test.",
    "selfReportedHivStatusWithPhotos": "The client self-reported an HIV {{result}} test result.",
    "patientResult": "Client interpretation",
    "cvResult": "AI interpretation",
    "clinicianResult": "Clinician interpretation",
    "myResult": "My interpretation",
    "noResult": "None",
    "fullTest": "Full test",
    "resultWindow": "Result window"
  },
  "ConversationEntry": {
    "title": "Conversation Summary",
    "noSummary": "No conversation summary is available yet as the conversation is still in progress.",
    "helpful": "Helpful",
    "notHelpful": "Not helpful"
  },
  "AddFollowupTaskDialog": {
    "addFollowUpTaskTitle": "Add new follow-up task",
    "followUpTaskTitle": "Task title",
    "followUpTaskDueDate": "Due date (optional)",
    "followUpTaskDescription": "Description (optional)",
    "invalidField": "Invalid field"
  },
  "CompleteTaskDialog": {
    "completeTaskTitle": "Mark complete",
    "completeTaskBody": "Marking this task as complete will remove it from the list of active tasks.",
    "actionsTaken": "Actions taken",
    "completionNotes": "Notes (optional)",
    "invalidField": "Invalid field"
  },
  "DeleteTaskDialog": {
    "title": "Delete task",
    "body": "Deleting this task will remove it from the list of active tasks.",
    "deletionNotes": "Notes (optional)"
  },
  "UnsavedChangesDialog": {
    "title": "Unsaved changes",
    "body": "You have a note or message that hasn't been saved or sent. If you leave now, it will be lost.",
    "stay": "Cancel & finish my note",
    "discard": "Proceed (discard)"
  },
  "FeedbackDialog": {
    "feedbackInfo": "We value your feedback.",
    "feedbackInfo_2": "Your input goes directly to the Audere team working on the Clinical Portal. It helps us understand your experience and make the tools you use even better.",
    "CategoryText": "Feedback category",
    "categoryErrorText": "Please select at least one feedback category.",
    "clinicalSpecificPortalText": "Feedback related to a specific Clinical Portal record?",
    "clinicalPortalID": "Clinical Portal ID",
    "clinicalPortalIDErrorText": "Please enter a Clinical Portal ID.",
    "descriptionText": "Describe the issue or what you suggest improving",
    "descriptionErrorText": "Description is required.",
    "priorityLabel": "Priority (Optional)",
    "submitText": "Submit Feedback",
    "priorityText_1": "Urgent",
    "priorityText_2": "General feedback",
    "feedbackCategories": {
      "technicalIssueBug": "Technical issue/bug",
      "newFeatureRequestIdea": "New feature request/idea",
      "suggestion": "Suggestion",
      "dataAccuracyConversationSummary": "Data accuracy - conversation summary",
      "dataAccuracyCollectedData": "Data accuracy - collected data",
      "dataAccuracyOther": "Data accuracy - other",
      "gratitudeNote": "Gratitude note",
      "other": "Other"
    },
    "descriptionCount": "{{count}}/5000"
  },
  "ViewClientPhoneReasonDialog": {
    "reasonForViewingPhoneNumberTitle": "Reason for viewing patient's phone number",
    "bodyText": "Provide a reason for accessing the client's phone number. This should only be done when contacting the client by phone.",
    "reasonFieldLabel": "Reason",
    "reasonPlaceholder": "Please enter the reason (up to 1000 characters)",
    "auditWarningMessage": "You are about to view a client's phone number. This action is logged.",
    "requiredField": "Reason field is required"
  },
  "ViewClientPhoneNumber": {
    "remainingTimeText": "(Visible for: {{seconds}} secs)",
    "viewPhoneNumber": "View Phone Number",
    "viewPhoneNumberAriaLabel": "View client phone number for a limited time after providing a reason"
  }
}
